import carousels from './carousels';

export default function initFilters() {
    var machineForm = $('form[machine-form]');

    machineForm.on('submit', function (e) {
        e.preventDefault();
        loadInputs(
            $(this).prop('action'),
            $('input:checkbox[name=nieuw]').prop('checked'),
            $('input:checkbox[name=occassions]').prop('checked'),
            $('input[name=keyword]').val(),
            $('select[name=category]').val(),
            $('select[name=brand]').val(),
            $('select[name=order]').val()
        );
    });

    if (machineForm.length > 0) {
        loadInputs(
            machineForm.prop('action'),
            $('input:checkbox[name=nieuw]').prop('checked'),
            $('input:checkbox[name=occassions]').prop('checked'),
            $('input[name=keyword]').val(),
            $('select[name=category]').val(),
            $('select[name=brand]').val(),
            $('select[name=order]').val()
        );
    }

    function loadInputs(route, nieuw, occassions, keyword, category, brand, order) {
        $.ajax(`${route}?&nieuw=${nieuw}&occassions=${occassions}&keyword=${keyword}&category=${category}&brand=${brand}&order=${order}`,
            {
                dataType: 'html',
                success: function (data) {
                    $('[data-machines]').empty().append(data);
                    carousels.professionals();
                },
                error: function (jqXhr) {
                    console.error(jqXhr);
                }
            }
        );
    }
}